import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { Input } from "components/Input/Input";
import { useFormik } from "formik";
import { OpcionPedagogicaI } from "interfaces/OpcionPedagogica";
import { useEffect } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { createOpcionPedagogicaSchema } from "schemas/opcionPedagogica/createOpcionPedagogicaSchema";
import {
  postOpcionPedagogica,
  putOpcionPedagogica,
} from "services/opcionPedagogica";

interface Props {
  actionType: "create" | "edit" | undefined;
  onClose?: any;
  elemento?: OpcionPedagogicaI;
  onSuccess?: (titulo: OpcionPedagogicaI) => void;
  showModal: boolean;
}

interface initialValues {
  id?: string | number;
  nombre: string;
}

export const OpcionPedagogicaABM = ({
  showModal,
  actionType,
  onClose,
  elemento,
  onSuccess,
}: Props) => {
  const isEditMode = actionType == "edit";
  const initialValues: initialValues = {
    nombre: "",
  };

  const renderInitialValues = async () => {
    let currentValues;

    if (isEditMode && elemento) {
      currentValues = {
        id: elemento?.id ?? "",
        nombre: elemento?.nombre ?? "",
      };
    } else {
      currentValues = initialValues;
    }
    setValues(currentValues);
  };

  const handleSubmitCreate = async (params: any) => {
    try {
      const newOpcionPedagogica = await postOpcionPedagogica({ params });
      showSuccessToast("¡La opción pedagógica fue creado con éxito!");
      if (onSuccess) onSuccess(newOpcionPedagogica);
      onClose();
    } catch (err: any) {
      showErrorToast("La opción pedagógica no pudo ser creado.");
      console.log(err.message);
    }
  };

  const handleSubmitEdit = async (params: any) => {
    try {
      const newOpcionPedagogica = await putOpcionPedagogica({ params });
      showSuccessToast("¡La opción pedagógica fue editado con éxito!");
      if (onSuccess) onSuccess(newOpcionPedagogica);
      onClose();
    } catch (err: any) {
      showErrorToast("La opción pedagógica no pudo ser creado.");
      console.log(err.message);
    }
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    isSubmitting,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema: createOpcionPedagogicaSchema,
    onSubmit: actionType == "create" ? handleSubmitCreate : handleSubmitEdit,
  });

  useEffect(() => {
    resetForm();
    if (actionType) {
      renderInitialValues();
    }
  }, [actionType]);

  return (
    <>
      <Modal show={showModal} onHide={onClose} size="lg" centered>
        <Modal.Header>
          <Modal.Title>
            {isEditMode
              ? "Editar Opción Pedagógica"
              : "Nueva Opción Pedagógica"}
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit}>
          <Modal.Body>
            <Col>
              <Row>
                <Col sm={12}>
                  <Input
                    id={"nombre"}
                    title="Nombre de la opción pedagógica"
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
              </Row>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="mx-3"
              variant="secondary"
              size="lg"
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              variant="primary"
              size="lg"
              className="user-submit-button"
              /* disabled={isSubmitting} */ type="submit"
            >
              {isEditMode ? "Guardar Cambios" : "Confirmar"}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
